export const USER_ROLE = "ADMIN";
export const AGENT_SCOPE = "AGENT_SCOPE";
export const PROFILE_SCOPE = "PROFILE_SCOPE";

export const DEFAULT_GUEST_MESSAGE = "Request failed with status code 401";

export const DEFAULT_FORM_DATA = {isValid: true, errorMessage: '', data: ''};
export const DEFAULT_ARRAY_FORM_DATA = {isValid: true, errorMessage: '', data: []};
export const DEFAULT_OBJECT_FORM_DATA = {isValid: true, errorMessage: '', data: {}};

export const DEFAULT_TOWN = 'Douala';
export const DEFAULT_PASSWORD = '000000';
export const DEFAULT_COUNTRY = 'CAMAEROUN';

export const UNKNOWN = 'INCONNU';

export const CURRENCY = ' xaf';